/* Functional Activator product page. Presentation only.

   NOTHING IN THIS FILE CHANGES THE LAYOUT OF THE BUY COLUMN AFTER FIRST PAINT.
   That is the whole rule it is written to. The price row, the size picker's head
   row, the size guide trigger, the saving pill and the green selected pill are all
   RENDERED by sections/main-product.liquid, so they are on the page, at their
   final size, in the first frame. Every earlier version of this file built one of
   them by moving or creating nodes once the page had loaded, and every one of them
   dropped the column in front of the shopper.

   What it does now, none of which changes layout outside a single control and none
   of which touches the purchase mechanism:
     1. orders the size options the way the size guide lists them, and gives each
        one its measurement, read from that guide rather than from a copy kept here
     2. rewrites the text of the already-rendered selected pill WHEN THE SHOPPER
        CHANGES THE SIZE
     3. drives the Fix My Posture Bundle add-on box
     4. starts each buy box on Large by pressing Large's own button once, on load,
        the way a shopper's tap would (startOnLarge)

   It never writes a value into the Activator's form, its variant id, its quantity,
   its Add to cart, its payment buttons, the cart or checkout. While the add-on is
   switched on it HIDES the Activator's form, which is presentation and is described
   at that code. Option VALUES are never altered, only the text shown for them and
   the order they are listed in, so the variant the theme submits is unchanged. The
   only values this file writes are the add-on's own: the bundle's variant id and the
   bundle's quantity, both inside the bundle's own native form. */
(function () {
  'use strict';

  /* The size guide already on the page is the single source for the size names,
     their measurements and the order they belong in. Editing the guide in the theme
     editor therefore keeps the picker in step, with no second copy to forget. */
  function readSizeGuide(root) {
    var order = [], measure = {};
    root.querySelectorAll('.ppro-sg table tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td, th');
      if (cells.length < 2) { return; }
      var name = cells[0].textContent.trim();
      var value = cells[1].textContent.trim();
      if (!name || !value || /^size$/i.test(name)) { return; }
      if (order.indexOf(name.toLowerCase()) === -1) { order.push(name.toLowerCase()); }
      measure[name.toLowerCase()] = value;
    });
    return { order: order, measure: measure };
  }

  function labelOptions(select, guide) {
    Array.prototype.forEach.call(select.options, function (opt) {
      var base = (opt.getAttribute('data-fa-pp-base') || opt.textContent).trim();
      opt.setAttribute('data-fa-pp-base', base);
      var m = guide.measure[base.toLowerCase()];
      opt.textContent = m ? base + ', ' + m : base;
    });
  }

  /* Reordering the option elements leaves the selection alone, because the browser
     tracks the selected OPTION rather than its index. Anything the guide does not
     name keeps its existing order and follows the ones it does. */
  function orderOptions(select, guide) {
    if (!guide.order.length) { return; }
    var opts = Array.prototype.slice.call(select.options);
    var rank = function (o) {
      /* A "-- Choose Option --" placeholder carries no value. It is not a size and
         it belongs at the top, so it is ranked before everything the guide names. */
      if (!o.value) { return -1; }
      var i = guide.order.indexOf((o.getAttribute('data-fa-pp-base') || o.textContent).trim().toLowerCase());
      return i === -1 ? guide.order.length + opts.indexOf(o) : i;
    };
    opts.slice().sort(function (a, b) { return rank(a) - rank(b); })
      .forEach(function (o) { select.appendChild(o); });
  }

  /* The price row, its saving pill and the head row are not built here.

     They were, and each one repainted the column after load: the row was lifted
     out of the buy buttons block, the saving was moved out of the compare-at <del>
     and reworded, and the data-fa-pp-saving attribute the green pill is drawn from
     was added by script, so until it arrived the saving was unpadded inline text
     and the row reflowed the moment it was styled.
     sections/main-product.liquid renders all of it, for this template only, with
     the final wording and the attribute already in place. There is nothing left
     here to lift, move, reword or style. */

  function init(root) {
    var picker = root.querySelector('.product-variants--select .product-variant');
    var select = picker && picker.querySelector('.product-variant-container');

    /* Size buttons (Master, 2026-11-03): the size picker block can draw the same choice as the
       theme's own radio buttons instead of a menu. There is nothing to label or reorder then,
       because each button reads its size and the product lists Small, Medium, Large in that
       order; only the green pill below follows the checked button. The inputs, their names and
       their change event are the theme's own, and nothing here writes to them. */
    var buttons = null;
    if (!select) {
      picker = root.querySelector('.product-variants--radio .product-variant');
      buttons = picker && picker.querySelector('[data-js-product-variant-container="radio"]');
      if (!buttons) { return; }
    } else {
      var guide = readSizeGuide(root);
      labelOptions(select, guide);
      orderOptions(select, guide);
    }

    /* NOTHING IN THIS COLUMN IS MOVED, CREATED OR RESTYLED AFTER PAINT.

       The head row, the size guide trigger, the price row, the saving pill and
       the green selected pill are all rendered by sections/main-product.liquid.
       Every one of them was once built here, after load, and every one of them
       dropped the column.

       What is left is the selected pill's TEXT. The pill is already on the page
       with the preselected size in it, so the first pass below writes the same
       words it already holds and moves nothing. After that it is only rewritten
       when the shopper changes the size, which is a one-line pill whose height
       does not depend on its words. */
    var label = picker.querySelector('.product-variant__name');
    var pill = root.querySelector('[data-fa-pp-selected]');

    /* The chosen size's name, or '' when nothing usable is chosen. The checked button is read
       afresh each time, so it stays right even if the theme redraws the buttons. */
    function chosen() {
      if (select) {
        var opt = select.options[select.selectedIndex];
        return opt && !opt.disabled ? (opt.getAttribute('data-fa-pp-base') || opt.textContent).trim() : '';
      }
      var input = root.querySelector('.product-variants--radio input[type="radio"]:checked');
      return input && !input.disabled ? input.value.trim() : '';
    }

    function report() {
      var name = chosen();
      var optionName = label ? label.textContent.trim() : 'Size';
      var short = optionName.split(/\s+/).pop();
      short = short.charAt(0).toUpperCase() + short.slice(1);
      if (pill) {
        if (name) {
          var next = short + ' ' + name + ' selected';
          if (pill.textContent.trim() !== next) { pill.textContent = next; }
          pill.removeAttribute('hidden');
        } else {
          pill.setAttribute('hidden', '');
        }
      }
    }

    var host = select || buttons;
    if (!host.hasAttribute('data-fa-pp-bound')) {
      host.setAttribute('data-fa-pp-bound', '');
      host.addEventListener('change', report);
      document.addEventListener('variant:change', report);
    }

    report();
  }

  /* The Featured Product block further down the page shows this same product and the same
     three sizes, so its dropdown is given the same measurements, read from the same guide
     table, and the two can never disagree.

     LABELS ONLY, and only inside that one section instance. It writes option TEXT and
     nothing else: no option VALUE, no order, no selected pill, no head row, no trigger, no
     element created, moved or restyled, and nothing in that section's form, variant,
     quantity, Add to cart, payment button, cart or checkout.

     The guide lives in the main section, so it is read from there. labelOptions records the
     original text in data-fa-pp-base and rebuilds from it, so repeated passes are idempotent.

     The labels survive a size change in that block, checked rather than assumed. Its picker
     does carry data-main-product-variants, so the theme's updateOptions does reach these
     options, but that function only sets attributes and toggles classes: it writes neither
     textContent nor innerHTML. And the select is not inside a [data-update-block], so the
     wholesale innerHTML replacement in renderProductUpdates does not reach it either. The
     only data-update-block nearby is the self-contained variant-data script. */
  function labelFeatured() {
    var main = document.querySelector('[data-fa-product-page]');
    if (!main) { return; }
    var guide = readSizeGuide(main);
    if (!guide.order.length) { return; }
    document
      .querySelectorAll('[id$="__featured_product_jgK74j"] .product-variants--select .product-variant-container')
      .forEach(function (select) { labelOptions(select, guide); });
  }

  /* Large first (Master, 2026-11-03). Large is the size most shoppers buy, so each buy box
     starts on Large instead of the theme's first size, Small.

     It is a shopper's tap, made once on load: Large's own button is clicked (or the menu set to
     Large and its change sent) through the theme's control, so the theme loads Large and updates
     its own form, price, pill and bar exactly as for a tap. This file writes nothing into a form,
     a variant id, Add to cart, the cart or checkout.
     - A link that names a size keeps it: ?variant=, as Google Shopping's links carry, and the
       address a shopper's own choice leaves behind for a reload.
     - A box whose Large is sold out, or whose size the shopper changed first, is left alone.
     - The theme also rewrites the address to ?variant= on a size change, which would drop a
       link's tracking tags from the address bar for every visitor. That one rewrite is held back
       with the theme's own data-no-history switch for the length of this tap only; the shopper's
       own taps update the address as before.

     WHAT IS SHOWN IS ALWAYS WHAT ADD TO CART SENDS. The theme checks the new size's button at
     once but moves its form only after it has loaded that size, and if the load fails it leaves
     the form where it was (component-product-form.js, renderProductUpdates). So:
     - Large is loaded first, through the theme's own preload (the hover it answers), and the tap
       is made once the theme holds it, so the button and the form change in the same step. The
       theme starts this preload itself whenever the picker is on screen; the hover covers a
       picker below the fold. If the preload has not arrived after three seconds, the tap is made
       anyway and the theme loads Large as for any tap.
     - If the form has still not moved to Large after that (at once from the theme's cache, or
       within ten seconds from a load), the box is put back on the size its form holds, with the
       same kind of tap. A shopper's own tap in the meantime ends all of this. */
  function startOnLarge(box) {
    /* Marked on the picker, not the box: the lower box's suffix also matches its inner
       product page and form, so one picker can be reached more than once. */
    var pv = box.querySelector('product-variants');
    if (!pv || pv.hasAttribute('data-fa-pp-large')) { return; }
    pv.setAttribute('data-fa-pp-large', '');
    if (/(^|&)variant=/.test(window.location.search.slice(1))) { return; }
    var isLarge = function (value) { return String(value || '').trim().toLowerCase() === 'large'; };
    var select = pv.querySelector('select[data-js-product-variant-container]');
    var radios = Array.prototype.slice.call(pv.querySelectorAll('input[type="radio"]'));
    var checked = function () { return radios.filter(function (r) { return r.checked; })[0] || null; };
    var large = select
      ? Array.prototype.filter.call(select.options, function (o) { return isLarge(o.value); })[0]
      : radios.filter(function (r) { return isLarge(r.value); })[0];
    if (!large || large.disabled || (select ? large.selected : large.checked)) { return; }
    var before = select ? select.value : checked();
    var untouched = function () { return select ? select.value === before : checked() === before; };
    var onLarge = function () { return select ? select.value === large.value : large.checked; };
    var formId = function () {
      var form = document.getElementById('product-form-' + pv.getAttribute('data-id'));
      var input = form && form.querySelector('[name="id"]');
      return input ? input.value : '';
    };
    /* The theme's cache of loaded sizes, keyed by option value id (one option here). */
    var cached = function () {
      return !!(pv._cachedOptions && pv._cachedOptions.has(large.getAttribute('data-option-value-id')));
    };

    /* One tap through the theme's own control, its address rewrite held back. */
    function tap(target) {
      var held = pv.hasAttribute('data-no-history');
      if (!held) { pv.setAttribute('data-no-history', ''); }
      try {
        if (select) {
          select.value = target.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.click();
        }
      } catch (e) {
        /* the theme's own update failed; the check below puts the box back */
      } finally {
        if (!held) { pv.removeAttribute('data-no-history'); }
      }
    }

    /* Back on the size the form holds, if the form never reached Large. */
    function restore() {
      var id = formId();
      var match = function (el) { return el.getAttribute('data-variant-id') === id; };
      var holds = select ? Array.prototype.filter.call(select.options, match)[0] : radios.filter(match)[0];
      if (holds && !(select ? holds.selected : holds.checked)) { tap(holds); }
    }

    function press() {
      if (!untouched()) { return; }
      var fromCache = cached();
      tap(large);
      if (fromCache) {
        if (onLarge() && formId() !== large.getAttribute('data-variant-id')) { restore(); }
        return;
      }
      var waited = 0;
      (function check() {
        if (!onLarge() || formId() === large.getAttribute('data-variant-id')) { return; }
        if (waited >= 10000) { restore(); return; }
        waited += 250;
        setTimeout(check, 250);
      })();
    }

    function whenLoaded() {
      if (!untouched()) { return; }
      try { large.dispatchEvent(new MouseEvent('mouseover')); } catch (e) { /* no preload: press loads Large */ }
      var waited = 0;
      (function ready() {
        if (!untouched()) { return; }
        if (cached() || waited >= 3000) { press(); return; }
        waited += 100;
        setTimeout(ready, 100);
      })();
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-variants').then(whenLoaded);
    } else {
      whenLoaded();
    }
  }

  function boot() {
    document.querySelectorAll('[data-fa-product-page]').forEach(init);
    labelFeatured();
    document.querySelectorAll('[data-fa-product-page], [id$="__featured_product_jgK74j"]').forEach(startOnLarge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Run again once the page has settled, because the size guide's table is what the
     measurements and the option order are read from and the app blocks around it
     arrive late. Both passes only relabel and reorder OPTIONS inside one select and
     rewrite one pill's text to what it already says, so a second pass cannot move
     the column. */
  window.addEventListener('load', boot);
})();
